import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormikProps } from 'formik';
import { FairPriceMethodEnum } from '@app/common';
import { useRootStore } from '../../../../providers/root-store-provider';

import { FairPriceFormValues } from '../../fair-price/form-values/fair-price-form-values-interface';
import { FairPriceTabDcf } from '../../fair-price/tab/dcf/fair-price-tab-dcf';
import { FairPriceTabFcf } from '../../fair-price/tab/fcf/fair-price-tab-fcf';
import { FairPriceTabLabel } from '../../fair-price/tab-label/fair-price-tab-label';
import { FairPriceTabPe } from '../../fair-price/tab/pe/fair-price-tab-pe';
import { ModalLoading } from '../../modal/loading/modal-loading';
import { Switcher } from '../../switcher/switcher';

interface FairPriceDialogContentProps {
    formikProps: FormikProps<FairPriceFormValues>;
}

export const FairPriceDialogContent: React.FC<FairPriceDialogContentProps> = observer(({ formikProps }) => {
    const {
        symbolsStore: { symbolFairPriceStore },
    } = useRootStore();

    const tabs: { label: React.ReactNode; value: FairPriceMethodEnum }[] = [
        {
            label: (
                <FairPriceTabLabel
                    labelKey="layout.dialogs.fairPrice.tabs.pe"
                    tooltipKey="layout.dialogs.fairPrice.info"
                />
            ),
            value: FairPriceMethodEnum.PE,
        },
        {
            label: (
                <FairPriceTabLabel
                    labelKey="layout.dialogs.fairPrice.tabs.fcf"
                    tooltipKey="layout.dialogs.fairPrice.fcf.info"
                />
            ),
            value: FairPriceMethodEnum.FCF,
        },
        {
            label: (
                <FairPriceTabLabel
                    labelKey="layout.dialogs.fairPrice.tabs.dcf"
                    tooltipKey="layout.dialogs.fairPrice.dcf.info"
                    showSmall
                />
            ),
            value: FairPriceMethodEnum.DCF,
        },
    ];

    if (symbolFairPriceStore.loading) {
        return <ModalLoading loading />;
    }

    return (
        <>
            <Switcher
                value={symbolFairPriceStore.activeTab}
                options={tabs}
                size="large"
                fullWidth
                activeColor="primary"
                marginBottom={'medium'}
                onChange={(value) => symbolFairPriceStore.setActiveTab(value)}
            />
            {symbolFairPriceStore.activeTab === FairPriceMethodEnum.PE && <FairPriceTabPe formikProps={formikProps} />}
            {symbolFairPriceStore.activeTab === FairPriceMethodEnum.FCF && (
                <FairPriceTabFcf formikProps={formikProps} />
            )}
            {symbolFairPriceStore.activeTab === FairPriceMethodEnum.DCF && (
                <FairPriceTabDcf formikProps={formikProps} />
            )}
        </>
    );
});
